// This form of concatenation is only used to get around VM optimizations that
// keep concatenated strings as linked lists of their parts. In most cases this
// is totally fine (and beneficial!), but w/ these very large strings that don't
// change often, it's better to free the memory. The memory impact is actually
// quite significant.
export const concatLgStr = (...parts: any[]): string => parts.join('')
